// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://mantlescan.xyz/address/0xEB0682d148e874553008730f0686ea89db7DA412
export const TRANSPARENT_PROXY_FACTORY = '0xEB0682d148e874553008730f0686ea89db7DA412';

// https://mantlescan.xyz/address/0x172867391d690Eb53896623DaD22208624230686
export const PROTOCOL_GUARDIAN = '0x172867391d690Eb53896623DaD22208624230686';

export const CHAIN_ID = 5000;
